import BaseLayout from '@/components/layouts/BaseLayout'

export default [{
  path: '/settings',
  navbar: false,
  title: 'settings',
  icon: 'ion ion-md-maps',
  name: 'settings',
  meta: { perm: 'Navbar.Settings' },
  component: BaseLayout,
  children: [{
    path: 'account-settings',
    title: 'account_settings',
    icon: 'fas fa-user',
    name: 'account-settings',
    component: () =>
      import('@/pages/Settings/Account')
  },
  {
    path: 'password_settings',
    title: 'update_password',
    icon: 'fas fa-key',
    name: 'password_settings',
    component: () =>
        import('@/pages/Settings/Password')
  },
  {
    path: 'login_informations',
    title: 'user_login_record',
    icon: 'fas fa-sign-in-alt',
    name: 'login_info',
    component: () =>
        import('@/pages/Settings/LoginInformations')
  },
  {
    path: 'system_settings',
    title: 'system_settings',
    icon: 'ion ion-ios-settings',
    name: 'system_settings',
    meta: { perm: 'Pages.SystemSetting' },
    component: () =>
        import('@/pages/Settings/SystemSetting')
  }
  ]
}
]
